import React, { useEffect, useState, useRef } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, isEmpty, isNotEmpty, useDebounce } from '../../lib/ep'
import { useCSS } from '../../lib/hooks';

import { PhonePrefixField } from './CountryField2';
import Input from './Input';

export const getCountriesPrefixes = (i18n, cb) => {
	$.get(getRemotedbUrl(`/v24/utils/getAvailableCountriesPhonePrefixes`), (res) => {
		if(res.length > 0) {
			let formatted_countries = [];
			res.map((c) => {
				formatted_countries.push({ id:c.k, name:i18n(c.v), prefix:c.p });
			})
			cb(formatted_countries.sort((a, b) => a.name.localeCompare(b.name)));
		} else {
			console.error("No countries found :(");
		}
	}, 'JSON');
}

// export phone number without prefix
export const singlePhone = (phone) => {
	const parsed_phone = parsePhone(phone);
	if(parsed_phone === false) return "";

	return parsed_phone.number;
};

// export phone number with prefix
export const singlePhoneWithPrefix = (phone, prettify = true) => {
	const parsed_phone = parsePhone(phone);
	if(parsed_phone === false) return "";

	if(parsed_phone.prefix == undefined) {
		return parsed_phone.number;
	}

	if(!prettify) return `${parsed_phone.prefix}${parsed_phone.number}`;

	return `+(${parsed_phone.prefix}) ${parsed_phone.number}`;
};

export const parsePhone = (phone) => {
	const phone_obj = { number:phone };
	if(isEmpty(phone_obj,'number',['']))return false
	if(phone == "" || !phone) return false;
	if(phone.indexOf("-") == -1) return phone_obj;

	const country_prefix = phone.substring(0, phone.indexOf("-"));
	const number = phone.substring(phone.indexOf("-") + 1);

	if(phone.indexOf("_") == -1) {
		return {
			prefix:country_prefix,
			number,
		};
	}
	
	const [ country, prefix ] = country_prefix.split('_');

	return { country, prefix, number };
}

export const validatePrefixAndPhone = (phone, min_digits, max_digits) => {
	let passed_phone = true;
	min_digits = min_digits ?? 6; 
	max_digits = max_digits ?? 15; 
	const _phone = parsePhone(phone);
	if(!_phone.prefix)return false;
	const re = new RegExp(`^[0-9]{${min_digits},${max_digits}}$`);
	passed_phone = re.test(_phone.number);
	if(!passed_phone)return false;
	return true;
}

const PhoneField = (props) => {
	useCSS('assets/phone_field.css');

	const raw_value = props?.value ?? ((props.model != undefined && props.model[props.name] != null) ? props.model[props.name] : '');
	const avail_countries = props?.avail_countries ?? null;
	const preferred_countries = props?.preferred_countries ?? null;
	const [ is_valid, setIsValid ] = useState(true);
	const [ phone, setPhone ] = useState('');
	const [ prefix, setPrefix ] = useState({ p:'', k:"" });
	const countries = useRef([]);
	const pref_countries = useRef([]);

	const min_digits = parseInt(props?.min_digits ?? '6');
	const max_digits = parseInt(props?.max_digits ?? '15');

	const setRawValue = (rv) => {
		if(rv == '') return;
		const parsed_phone = parsePhone(rv);
		setPhone(parsed_phone.number);
		setPrefix({ k:parsed_phone.country, p:parsed_phone.prefix });
	}

	useEffect(() => {
		setRawValue(raw_value)
	}, [ raw_value ]);

	useEffect(() => {
		if(isNotEmpty(prefix,'p') && isNotEmpty(prefix,'k')){
			validateFormat(phone);
			if(phone != '')change('phone', phone.replace(/\D/g, ""));
		}
	}, [ prefix ]);

	const setCountries = (countries_list) => {
		countries.current = countries_list;
		if(countries.current.length == 1 && pref_countries.current.length <= 1){
			if(raw_value=='')setPrefix(countries_list[0]);
		}
	};

	const setPreferredCountries = (preferred_countries_list) => {
		pref_countries.current = preferred_countries_list;
		if(preferred_countries && preferred_countries.length>0){
			const default_preferred_country = preferred_countries[0];
			if(raw_value=='')setPrefix((pref_countries.current).find((locale) => (locale.k == default_preferred_country)));
		}
	};

	const validateFormat = (value) => {
		if(props.onValidate != undefined) props.onValidate(true);//considerem valid d'inici i ja evaluem a posteriori (neteja errors visuals)
		let passed_phone = true;
		if(value != '') {
			const re = new RegExp(`^[0-9]{${min_digits},${max_digits}}$`);
			passed_phone = re.test(value);
		}
		let passed_prefix = prefix.p != '' && prefix.k != '';

		const _is_valid = passed_prefix && passed_phone ? true : false;
		setIsValid(_is_valid);
		if(props.onValidate != undefined) props.onValidate(_is_valid, props.name, "Invalid phone number");
	};

	const debouncedValidatePhone = useDebounce(phone, 300);
	useEffect(() => {
		if(debouncedValidatePhone) validateFormat(phone);
	}, [ debouncedValidatePhone ]);

	const changePrefix = (k, v) => {
		//prefix.p = v.p;
		//prefix.k = v.k;
		if(phone!='')change(props.name, phone);
		setTimeout(()=>setPrefix(v),100);//change && set at different moment
	};

	const change = (k, v) => {
		let phone = '';
		for(let i = 0; i < v.length; i ++) {
			phone += (v.charAt(i) == " ") ? "" : v.charAt(i);
		}
		let full_phone = phone;
		if(isNotEmpty(prefix,'k') && isNotEmpty(prefix,'p')) {
			full_phone = `${prefix.k}_${prefix.p}-${phone}`;
		}
		if(props.change != undefined) props.change(k, full_phone);
	};

	var newp = { ...props, change:(k, v) => change(k, v), errors:{...props.errors} };
	if(newp.errors == undefined) newp.errors = {};
	if(newp._type == undefined) newp._type = 'tel';

	const _field_styles = newp?._field_style ?? {};

	//if(newp.placeholder == undefined) newp.placeholder = props.intl.formatMessage({ id:"2505550199" });	// (250) 555-0199

	if(props.errors != undefined && props.errors[props.name] != undefined) {
		newp.errors[props.name] = props.errors[props.name];
	} else if(!is_valid) {
		newp.errors[props.name] = "Invalid phone number";
	} else {
		newp.errors = {};
	}

	if(newp.passed != undefined) {
		newp.onBlur = () => newp.passed(is_valid);
	}

	const display_flags = props?.display_flags ?? true;

	let field_classes = ['react_field', 'gui_phone_input'];
	if(newp._field_class != undefined) field_classes.push(newp._field_class);
	if(display_flags) field_classes.push('with_flags');

	const disabled_for_prefix = avail_countries != null && (avail_countries.length > 1 && (prefix.k == undefined || prefix.k == '')) ? true : false;
	const disabled_for_props = props?.disabled ?? false;

	const row_h = props?.row_h ?? false;
	const display_w = props?.display_w ?? false;

	if(row_h !== false) _field_styles['--real-phone-prefix-h'] = row_h;
	if(display_w !== false) _field_styles['--phone-prefix-w'] = display_w;


	const only_available = props?.only_available ?? true;
	return (
		<div class={field_classes.join(" ")} style={_field_styles}>
			<div class="this_input">
				<Input
					{...newp}
					display_error_at_bottom={true}
					value={phone}
					_field_class='top_field'
					disabled={(disabled_for_prefix || disabled_for_props)}
					custom_input_contents={<PhonePrefixField
						avail_countries={avail_countries}
						preferred_countries={preferred_countries}
						only_available={only_available}
						display_flags={display_flags}
						is_enabled={!disabled_for_props}
						country={prefix?.k ?? ''}
						setCountries={setCountries}
						setPreferredCountries={setPreferredCountries}
						onChange={changePrefix}
					/>}
				>{newp.children}</Input>
			</div>
		</div>
	);
}

export default injectIntl(PhoneField);